import { useLanguage } from '../contexts/LanguageContext';
import { Smartphone, Zap, Palette } from 'lucide-react';

export const ProblemsSection = () => {
  const { t } = useLanguage();

  const problems = [
    {
      icon: Smartphone,
      titleKey: 'problem1Title',
      descKey: 'problem1Desc',
    },
    {
      icon: Zap,
      titleKey: 'problem2Title',
      descKey: 'problem2Desc',
    },
    {
      icon: Palette,
      titleKey: 'problem3Title',
      descKey: 'problem3Desc',
    },
  ];

  return (
    <section
      id="problems"
      data-testid="problems-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section title */}
        <h2
          data-testid="problems-title"
          className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-16 fade-in-up"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          {t('problemTitle')}
        </h2>

        {/* Problems grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {problems.map((problem, index) => (
            <div
              key={problem.titleKey}
              data-testid={`problem-card-${index + 1}`}
              className={`glass-card p-8 rounded-2xl fade-in-up stagger-${index + 1}`}
            >
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6">
                <problem.icon className="w-7 h-7 text-primary" />
              </div>
              <h3
                className="text-xl md:text-2xl font-semibold text-foreground mb-4"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                {t(problem.titleKey)}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {t(problem.descKey)}
              </p>
            </div>
          ))}
        </div>

        {/* Solution text */}
        <div
          data-testid="solution-text"
          className="mt-16 p-8 md:p-12 rounded-2xl glass-card border-primary/20 fade-in-up stagger-4"
        >
          <p className="text-lg md:text-xl text-foreground leading-relaxed">
            <span className="text-primary font-semibold">→</span>{' '}
            {t('solutionText')}
          </p>
        </div>
      </div>
    </section>
  );
};
